/* Minéral — zone « tester avant d'acheter » (snippets/mpn-try-zone.liquid).
   - Recopie la police, la taille, la graisse, l'espacement et la hauteur du bouton vert « Ajouter au panier »
     visible (formulaire principal, pas la barre flottante) sur les boutons blancs.
   - Texte toujours sur une ligne : si un libellé ne tient pas (écran très étroit), la taille est réduite pas à pas.
   - Bouton « Commander un échantillon » : le panneau se déroule juste en dessous (200 ms, sans animation si
     prefers-reduced-motion), aria-expanded ; un seul panneau ouvert à la fois. Photos chargées à la 1re ouverture
     (méthode loadGridImages du bloc mpn-sample-feuilles).
   - Bouton surface test : ajout direct au panier par le script existant (.sample-button[data-sample-variant-id]) ;
     masque la zone si la surface test est masquée (pièce d'angle) et seule.
   - État du bouton surface test recalculé à partir de /cart.js (au chargement et à chaque mise à jour du panier),
     avec la même règle que le thème (étiquette « echantillon » sans « surface-test-hors-offre », lue dans /products/x.js) :
       aucune surface test de l'offre au panier -> « Tester 1 m² chez vous   prix 1re » (variante 1)
       1 ou 2 autres                            -> « Ajouter cette surface test   prix 2e/3e » (variante 2)
       celle-ci au panier                       -> « Surface test ajoutée ✓ » (désactivé)
       3 au panier                              -> désactivé + phrase « Vous testez déjà 3 modèles… » (inchangé)
     Le rendu serveur (Liquid) donne déjà le même état : pas de saut à l'affichage.
   - Mode démo (aperçu de thème uniquement, jamais sur le thème en ligne) : ?mpn_try_demo=0|1|self|3 simule le panier
     pour l'affichage seulement ; rien n'est ajouté, le clic sur le bouton ne fait rien. */
(function () {
  if (window.__mpnTryZone) return;
  window.__mpnTryZone = true;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function greenButton(zone) {
    var box = zone.closest('.buy-btns') || document;
    return (
      box.querySelector('.product-form__buttons.no-sticky__buttons .product-form__submit') ||
      document.querySelector('.product__info-container .product-form__buttons.no-sticky__buttons .product-form__submit')
    );
  }

  function copyStyle(zone) {
    var g = greenButton(zone);
    if (!g) return;
    var cs = window.getComputedStyle(g);
    if (!g.getClientRects().length) return; // bouton non affiché : valeurs de repli du CSS (identiques au thème)
    if (cs.fontSize) zone.style.setProperty('--mpn-try-fs', cs.fontSize);
    zone.style.setProperty('--mpn-try-fw', cs.fontWeight || '400');
    zone.style.setProperty('--mpn-try-ls', cs.letterSpacing === 'normal' ? '0' : cs.letterSpacing);
    zone.querySelectorAll('.mpn-try__btn').forEach(function (b) {
      b.style.fontFamily = cs.fontFamily;
    });
    var h = g.getBoundingClientRect().height;
    if (h > 20) zone.style.setProperty('--mpn-try-h', Math.round(h) + 'px');
  }

  // Le libellé ne doit jamais déborder ni passer sur 2 lignes : on mesure le texte (et non le bouton,
  // dont le contenu centré déborde des deux côtés), on réduit jusqu'à 13 px ; si ça ne suffit pas,
  // le prix sort du bouton et passe au début de la ligne grise (« 19,90 € · 4 pièces … »).
  var MIN_FS = 13;
  function tooWide(b) {
    var txt = b.querySelector('.mpn-try__txt');
    if (!txt) return b.scrollWidth > b.clientWidth + 1;
    var cs = window.getComputedStyle(b);
    var avail = b.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    return txt.scrollWidth > avail + 0.5;
  }
  function shrink(b) {
    b.classList.remove('is-fit');
    b.style.removeProperty('--mpn-try-fit');
    var fs = parseFloat(window.getComputedStyle(b).fontSize) || 16;
    var guard = 0;
    while (tooWide(b) && fs > MIN_FS && guard < 20) {
      fs -= 0.5;
      guard++;
      b.style.setProperty('--mpn-try-fit', fs + 'px');
      b.classList.add('is-fit');
    }
    return !tooWide(b);
  }
  function fit(zone) {
    if (!zone) return;
    var note = zone.querySelector('.mpn-try__note');
    var old = note && note.querySelector('.mpn-try__note-price');
    if (old) old.remove();
    var moved = '';
    zone.querySelectorAll('.mpn-try__btn').forEach(function (b) {
      b.classList.remove('is-noprice');
      if (b.hidden || !b.clientWidth) return;
      if (shrink(b)) return;
      var price = b.querySelector('.mpn-try__price');
      if (price && price.innerHTML.trim()) {
        b.classList.add('is-noprice');
        shrink(b);
        if (!moved) moved = price.innerHTML;
      } else {
        // dernier recours : taille minimale du script d'origine
        var fs = parseFloat(window.getComputedStyle(b).fontSize) || 13;
        while (tooWide(b) && fs > 10) {
          fs -= 0.5;
          b.style.setProperty('--mpn-try-fit', fs + 'px');
          b.classList.add('is-fit');
        }
      }
    });
    if (moved && note) {
      var sp = document.createElement('span');
      sp.className = 'mpn-try__note-price';
      sp.innerHTML = moved + ' · ';
      note.insertBefore(sp, note.firstChild);
    }
  }

  function loadSamples(panel) {
    var el = panel.querySelector('mpn-sample-feuilles');
    if (!el) return;
    var go = function () {
      if (typeof el.loadGridImages === 'function') el.loadGridImages();
    };
    if (window.customElements && !customElements.get('mpn-sample-feuilles')) {
      customElements.whenDefined('mpn-sample-feuilles').then(go);
    } else {
      go();
    }
  }

  function animate(p, open) {
    clearTimeout(p._mpnAnim);
    p.style.transition = '';
    if (reduceMotion()) {
      p.hidden = !open;
      p.style.height = '';
      return;
    }
    if (open) {
      p.hidden = false;
      var h = p.scrollHeight;
      p.style.height = '0px';
      p.offsetHeight; // reflow
      p.style.transition = 'height 200ms ease-out';
      p.style.height = h + 'px';
      p._mpnAnim = setTimeout(function () {
        p.style.transition = '';
        p.style.height = '';
      }, 220);
    } else {
      p.style.height = p.scrollHeight + 'px';
      p.offsetHeight;
      p.style.transition = 'height 200ms ease-out';
      p.style.height = '0px';
      p._mpnAnim = setTimeout(function () {
        p.hidden = true;
        p.style.transition = '';
        p.style.height = '';
      }, 220);
    }
  }

  function setOpen(zone, btn, open) {
    var p = document.getElementById(btn.getAttribute('aria-controls'));
    if (!p) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) loadSamples(p);
    animate(p, open);
  }

  function onClick(e) {
    var btn = e.target.closest && e.target.closest('[data-mpn-try-btn]');
    if (!btn) return;
    var zone = btn.closest('[data-mpn-try]');
    if (!zone) return;
    e.preventDefault();
    var open = btn.getAttribute('aria-expanded') === 'true';
    zone.querySelectorAll('[data-mpn-try-btn]').forEach(function (b) {
      if (b !== btn && b.getAttribute('aria-expanded') === 'true') setOpen(zone, b, false);
    });
    setOpen(zone, btn, !open);
  }

  // Surface test masquée (pièce d'angle) : si c'est le seul bouton, toute la zone est masquée (note comprise)
  function syncSt(zone) {
    var sb = zone.querySelector('sample-button');
    if (!sb) return;
    var smp = zone.querySelector('[data-mpn-try-btn="smp"]');
    zone.hidden = !!sb.hidden && !smp;
  }

  function refresh(zone) {
    copyStyle(zone);
    fit(zone);
  }

  function init(zone) {
    if (zone._mpnTry) return;
    zone._mpnTry = true;
    syncSt(zone);
    refresh(zone);
    var p = zone.querySelector('.mpn-try__btns');
    if (p && window.MutationObserver) {
      new MutationObserver(function () {
        syncSt(zone);
      }).observe(p, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function all(fn) {
    document.querySelectorAll('[data-mpn-try]').forEach(fn);
  }

  /* ---------- État du bouton surface test (panier) ---------- */
  var DEMO = (function () {
    try {
      var v = new URLSearchParams(window.location.search).get('mpn_try_demo');
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (v === null || !role || role === 'main') return null; // jamais sur le thème en ligne
      var map = { 0: { n: 0, self: false }, 1: { n: 1, self: false }, self: { n: 1, self: true }, 3: { n: 3, self: false } };
      return map[v] || null;
    } catch (e) {
      return null;
    }
  })();
  var tagCache = {};
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }
  function isOffer(handle) {
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle]);
    var key = 'mpnTryTag:' + handle;
    try {
      var c = window.sessionStorage.getItem(key);
      if (c === '1' || c === '0') return Promise.resolve((tagCache[handle] = c === '1'));
    } catch (e) {}
    return getJSON(root() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (p) {
        var tags = (p && p.tags) || [];
        var ok = tags.indexOf('echantillon') !== -1 && tags.indexOf('surface-test-hors-offre') === -1;
        tagCache[handle] = ok;
        try {
          window.sessionStorage.setItem(key, ok ? '1' : '0');
        } catch (e) {}
        return ok;
      })
      .catch(function () {
        return false;
      });
  }
  // { n: nombre de surfaces test de l'offre au panier, ids: produits au panier }
  function cartInfo() {
    return getJSON(root() + 'cart.js').then(function (cart) {
      if (!cart || !cart.items) return null;
      var handles = {};
      cart.items.forEach(function (it) {
        handles[it.handle] = true;
      });
      var list = Object.keys(handles);
      return Promise.all(list.map(isOffer)).then(function (res) {
        var offer = {};
        list.forEach(function (h, i) {
          offer[h] = res[i];
        });
        var info = { n: 0, ids: {} };
        cart.items.forEach(function (it) {
          info.ids[String(it.product_id)] = true;
          if (offer[it.handle]) info.n += it.quantity;
        });
        return info;
      });
    });
  }
  // Structure du bouton (libellé + prix) : reconstruite si un autre script a réécrit son contenu
  function ensureStructure(sb) {
    var btn = sb.querySelector('button.sample-button') || sb.querySelector('.mpn-try__btn');
    if (!btn) return null;
    if (!btn.classList.contains('mpn-try__btn')) btn.classList.add('mpn-try__btn');
    var txt = btn.querySelector('.mpn-try__txt');
    if (!txt) {
      txt = btn.querySelector('.sample-button__text') || document.createElement('span');
      txt.className = 'mpn-try__txt sample-button__text';
      if (!txt.parentNode) btn.insertBefore(txt, btn.firstChild);
    }
    if (!txt.querySelector('.mpn-try__lbl') || !txt.querySelector('.mpn-try__price')) {
      txt.innerHTML = '<span class="mpn-try__lbl"></span><span class="mpn-try__price"></span>';
    }
    // texte orphelin ajouté hors de .mpn-try__txt (ex. libellé réécrit) : retiré
    Array.prototype.slice.call(btn.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.textContent.trim()) n.remove();
    });
    return btn;
  }
  var lastInfo = null;
  function renderSt(sb, info) {
    var d = sb.dataset;
    var btn = ensureStructure(sb);
    if (!btn) return;
    if (info) lastInfo = info;
    info = info || lastInfo || { n: 0, ids: {} };
    var lbl = btn.querySelector('.mpn-try__lbl');
    var price = btn.querySelector('.mpn-try__price');
    var zone = sb.closest('[data-mpn-try]');
    var note = zone && zone.querySelector('.mpn-try__note');
    var duo = d.duo === 'true';
    var offer = d.offer === 'true' || !!DEMO;
    var self = DEMO ? DEMO.self : !!info.ids[d.sp];
    var n = DEMO ? DEMO.n : info.n;
    var state = 'none';
    if (offer) state = self ? 'incart' : n >= 3 ? 'full' : n >= 1 ? 'extra' : 'first';
    var useV2 = state === 'extra' && !!d.v2;
    var p = d.showPrice === 'true' ? (useV2 ? d.p2 : d.p1) : '';
    var l = self ? d.l3 : duo ? d.ls : state === 'extra' ? d.l2 : d.l1;
    var nt = state === 'extra' ? d.n2 : state === 'incart' ? d.n3 : state === 'full' ? d.n4 : d.n1;
    if (lbl && lbl.textContent !== l) lbl.textContent = l;
    if (price) {
      var ph = self || duo ? '' : p;
      if (price.innerHTML !== ph) price.innerHTML = ph;
    }
    btn.setAttribute('data-sample-variant-id', useV2 ? d.v2 : d.v1);
    var off = self || state === 'full';
    if (!btn.classList.contains('loading')) btn.disabled = off;
    if (off) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    sb.classList.toggle('mpn-try__st--added', self);
    ['first', 'extra', 'incart', 'full'].forEach(function (s) {
      sb.classList.toggle('mpn-st-offer--' + s, state === s);
    });
    if (note) {
      if (duo) {
        // note commune « Échantillon … · surface test <prix> · … » : seul le prix de la surface test change
        var old = d.pshown || '';
        if (old && p && old !== p && note.innerHTML.indexOf(old) !== -1) {
          note.innerHTML = note.innerHTML.replace(old, p);
          d.pshown = p;
        }
      } else {
        var cur = note.innerHTML.replace(/<span class="mpn-try__note-price">[\s\S]*?<\/span>/, '');
        if (cur !== nt) note.innerHTML = nt;
      }
    }
    fit(zone);
  }
  function updateStates() {
    var sbs = document.querySelectorAll('[data-mpn-try] sample-button[data-mpn-st-zone]');
    if (!sbs.length) return;
    var go = function (info) {
      if (!info) return;
      sbs.forEach(function (sb) {
        renderSt(sb, info);
      });
    };
    if (DEMO) return go({ n: 0, ids: {} });
    cartInfo().then(go).catch(function () {});
  }
  // NB : data-p1 / data-p2 / data-pshown contiennent le HTML du prix (« 125&nbsp;€ »), comparé tel quel à innerHTML
  // Mode démo : le clic sur le bouton surface test ne fait rien (capturé avant tout autre script)
  if (DEMO) {
    window.addEventListener(
      'click',
      function (e) {
        var b = e.target.closest && e.target.closest('[data-mpn-try] sample-button[data-mpn-st-zone] .mpn-try__btn');
        if (!b) return;
        e.preventDefault();
        e.stopImmediatePropagation();
      },
      true
    );
  }
  var updT, updT2;
  function updateLater() {
    clearTimeout(updT);
    clearTimeout(updT2);
    updT = setTimeout(updateStates, 150);
    updT2 = setTimeout(updateStates, 1200); // 2e passage : panier recalculé par le tiroir (échanges 1re / 2e surface test)
  }
  // Toute modification du panier (ajout depuis la zone, suppression / quantité dans le tiroir, autre script)
  // relance le calcul de l'état depuis /cart.js
  (function () {
    if (!window.fetch || window.__mpnTryFetch) return;
    window.__mpnTryFetch = true;
    var f0 = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = f0.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) {
        p.then(function (r) {
          if (r && r.ok) updateLater();
        }).catch(function () {});
      }
      return p;
    };
  })();
  ['cart:updated', 'cart:refresh', 'cart-drawer:refresh'].forEach(function (ev) {
    document.addEventListener(ev, updateLater);
  });
  // Bouton réécrit par un autre script (état de chargement…) : structure et état rétablis aussitôt
  function watchSt() {
    document.querySelectorAll('[data-mpn-try] sample-button[data-mpn-st-zone]').forEach(function (sb) {
      if (sb._mpnWatch || !window.MutationObserver) return;
      sb._mpnWatch = true;
      var busy = false;
      new MutationObserver(function () {
        if (busy) return;
        var btn = sb.querySelector('button');
        if (btn && btn.querySelector('.mpn-try__lbl') && btn.querySelector('.mpn-try__price') && btn.classList.contains('mpn-try__btn')) return;
        busy = true;
        renderSt(sb, null);
        setTimeout(function () {
          busy = false;
        }, 0);
      }).observe(sb, { subtree: true, childList: true, characterData: true });
    });
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateLater);
    } catch (e) {}
  }

  document.addEventListener('click', onClick);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      all(refresh);
    }, 150);
  });
  document.addEventListener('mpn-try:sync', function () {
    all(function (z) {
      syncSt(z);
      refresh(z);
    });
    updateLater();
  });

  function start() {
    all(init);
    watchSt();
    updateStates();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        all(refresh);
      });
    }
    // le bouton vert peut être restylé après chargement (scripts de la fiche) : 2e mesure
    setTimeout(function () {
      all(refresh);
    }, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
